/*
 * @Author: your name
 * @Date: 2019-12-17 23:11:27
 * @LastEditTime : 2020-01-21 18:28:07
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\creditEvaluation.js
 */
import CreditEvaluation from '@/views/creditEvaluation/index'//信用评价
const creditEvaluationRouter = [
    {
        path: '/creditEvaluation',
        name: 'creditEvaluation',
        component: CreditEvaluation,
        meta: {
            name: '信用评价'
        }
    }
]
export default creditEvaluationRouter;


// WEBPACK FOOTER //
// ./src/router/modules/creditEvaluation.js